import { Service } from 'core/types/service';

export const SET_CUSTOMER_SERVICES = 'SET_CUSTOMER_SERVICES';

export class SetCustomerServices {
  readonly type = SET_CUSTOMER_SERVICES;
  readonly payload: {
    customer: number;
    services: Array<Service & { pivot: { price: number } }>;
  };

  constructor(
    customer: number,
    services: Array<Service & { pivot: { price: number } }>
  ) {
    this.payload = { customer, services };
  }
}

export type Action = SetCustomerServices;
